"use client";

import { ArrowUpDown, ChevronDown } from "lucide-react";
import { useTranslations } from "next-intl";
import type { SortOption } from "./SortDialog";

interface SortTriggerProps {
  /** null = 명시 정렬 없음 → "추천순" */
  sortBy: SortOption | null;
  onOpen: () => void;
}

const SORT_LABEL_KEY: Record<SortOption, string> = {
  price_low: "priceLow",
  price_high: "priceHigh",
  newest: "newest",
};

/** 목록 헤더(건수 줄) 오른쪽 끝의 정렬 텍스트 버튼 — 누르면 SortDialog 를 연다. */
export default function SortTrigger({ sortBy, onOpen }: SortTriggerProps) {
  const t = useTranslations("search.sort");
  const label = sortBy ? t(SORT_LABEL_KEY[sortBy]) : t("recommended");

  return (
    <button
      type="button"
      onClick={onOpen}
      className="inline-flex items-center gap-0.5 text-[13px] font-medium text-gray-700 shrink-0 cursor-pointer"
    >
      <ArrowUpDown className="w-3.5 h-3.5 text-gray-500" />
      <span>{label}</span>
      <ChevronDown className="w-3.5 h-3.5 text-gray-400" />
    </button>
  );
}
